document.addEventListener("alpine:init", () => {
    Alpine.data("footerTerritorySwitcher", (current, langs) => ({
        active: false,
        current: current,
        availableLangs: langs,
        browserLang: navigator.language || navigator.userLanguage,
        dropdownOpen: false,
        mobileNavOpen: false,
        init() {
            console.log("Current browser lang " + this.current);

            if (this.browserLang.toLowerCase() != this.current.toLowerCase()) {
                if (
                    this.availableLangs.includes(this.browserLang.toLowerCase())
                ) {
                    this.active = true;
                }
            }
        },
        openDropdown() {
            if (this.dropdownOpen) {
                this.dropdownOpen = false;
            } else {
                this.dropdownOpen = true;
            }
        },
    }));
});
